import { all, fork } from "redux-saga/effects";
import { watchGetLogin } from "./sagas/loginSaga";
import { watchOperationData } from "./sagas/operationHomeSaga";
import { watchAgentHomeData } from "./sagas/agentHomeSaga"; // Import the agentHome saga

const rootSaga = function* () {
  yield all([
    fork(watchGetLogin),
    fork(watchOperationData),
    fork(watchAgentHomeData),
  ]);
};

export default rootSaga;
